<script setup lang="ts">
import type {HTMLAttributes} from 'vue'
import {ToastViewport} from 'reka-ui'
import {cn} from '@/lib/utils'

const props = defineProps<{class?: HTMLAttributes['class']}>()
</script>

<template>
  <ToastViewport
    :class="
      cn(
        'fixed right-0 top-0 z-[100] flex max-h-screen w-full flex-col gap-2 p-4 sm:right-4 sm:top-4 sm:max-w-[420px]',
        props.class
      )
    " />
</template>
